<template>
	<div class="container-fluid" id="mainDiv">		
	<transition-group
					enter-active-class="animated fadeIn"
					leave-active-class="animated fadeOut"  
					mode="out-in">
		<div class="col-xs-12 text-center" key="navBar">	
			 	<!-- <router-link to="/" active-class="active" exact>  -->
			 		<button
			 				id="mobileBtn"
			 				:class="audioEngageClass"
			 				@click.once="mobileEngage">	
			 		{{mobileTxt}}
			 		</button>		
			 	<!-- </router-link> -->
			 	<p id="welcomeMobileText" v-show="showMobileText" style="color: black;"> 
			 			Access this app on your computer for extra effects and reactive backgrounds.
			 		<br>
			 		<br>
			 		<br>
				 		<i :class="bellSlash"></i> </i> 
				 		<br>
				    	Please make sure your <strong> mute button is off </strong> and volume is engaged.
			 	</p>

			 	
			      	


		</div>
	</transition-group>					
	</div>
</template>

<script>
import StartAudioContext from '../../node_modules/startaudiocontext/StartAudioContext.js'
import Tone from '../../node_modules/Tone/build/Tone.min.js'
	export default {

		data: () => ({
			onlyBtn:   			true,
			bellBoolean: 		false,
			showMobileText: 	true,
			mobileTxt:      	"Engage Mobile Audio",
			mobileWelcomeBlink: new Tone.Player({
			  						"playbackRate" : 1,
			  						"loop" : false,
			  						"volume": -6,
			  						}).toMaster(),
		}),
		created (){
			let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            // if (isMobile) 
		    // { 
		        // this.$router.push('/mobile'); 
		    // } else if (!isMobile){
		        // this.$router.push('/'); 
		    // }
			this.loadAudio();
			setTimeout(this.bellTrue, 1500);
			setTimeout(this.bellFalse, 3000);
			setTimeout(this.bellTrue, 4500);
			setTimeout(this.bellFalse, 6000);
			setTimeout(this.bellTrue, 7500);
			// setTimeout(this.mobileEngage, 500);
		},
		computed: {
			audioEngageClass(){
				return{
					"btn btn-helpBtn1 btn-lg": this.onlyBtn,
					"btn btn-helpBtn2 btn-lg": !this.onlyBtn,
				}
			},
			bellSlash(){
					return{
						"fa fa-bell fa-2x": this.bellBoolean,
						"fa fa-bell-slash fa-2x": !this.bellBoolean,
						"greenBell": this.bellBoolean
					}
			}
		},
		methods: {
			bellTrue(){
					this.bellBoolean = true;
			},
			bellFalse(){
					this.bellBoolean = false;
			},	
			mobileEngage(){
					setTimeout(()=>{
						this.mobileWelcomeBlink.start();
					}, 150);	
					this.mobileTxt = "Engaged!";
					this.onlyBtn = false;	
					this.showMobileText = false;
					// setTimeout(this.startAudio, 300);	
					setTimeout(()=> {this.$router.push('/');}, 300);
					
					setTimeout(()=>{
						this.mobileWelcomeBlink.disconnect();
					}, 2000);		
			},
			loadAudio(){
				let ua = window.navigator.userAgent;

				let 
				isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
				isFirefox = typeof InstallTrigger !== 'undefined',
				isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification),
				isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0,
				isIE = /*@cc_on!@*/false || !!document.documentMode,
				isEdge = !isIE && !!window.StyleMedia,
				isBlink = (isChrome || isOpera) && !!window.CSS,
				iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i),
				AndroidMobile = /Android/i.test(navigator.userAgent);

					if (AndroidMobile === true ||
						isChrome === true || 
						isOpera === true || 
						isFirefox === true || 
						isBlink === true){
							this.mobileWelcomeBlink.load("../src/assets/sounds/blinks/welcomeBlink.ogg");		
					} else if (
						iOS === true ||
						isSafari === true || 
						isEdge === true || 
						isIE === true){
							this.mobileWelcomeBlink.load("../src/assets/sounds/blinks/welcomeBlink.m4a");
					}
			},
			// startAudio(){
			// 		// Tone.context = new AudioContext();
			// 		StartAudioContext(Tone.context, "#mobileBtn");
			// 		this.$router.push('/');
			// },
		}
	}
</script>
<style>
.greenBell{
color: gold;	
}
html, body{
	background: white;
}
/* BOOTSTRAP COLORS 		*/
			.btn-helpBtn1:hover,
			.btn-helpBtn1:active:hover,
			.btn-helpBtn1,
			.btn-helpBtn1:focus, 
			.btn-helpBtn1:active, 
			.btn-helpBtn1:active, 
			.btn-helpBtn1:active:focus,
			.open>.dropdown-toggle.btn-helpBtn1 {
			color: black;
			background-color: transparent;
			border-color: black; 
			border-width: 2px;    
			text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.6);
			-webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.3);
            box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);  
			}

			.btn-helpBtn2:hover,
			.btn-helpBtn2:active:hover,
			.btn-helpBtn2,
			.btn-helpBtn2:focus, 
			.btn-helpBtn2:active, 
			.btn-helpBtn2:active, 
			.btn-helpBtn2:active:focus,
			.open>.dropdown-toggle.btn-helpBtn2 {
			color: black;
			background-color: transparent;
			border-color: black; 
			border-width: 2px;      
			}
/* BACKGROUND COLOR CHANGES */
			/*.btn:hover, .btn:focus, .btn.focus{
			color: inherit;	
			}*/
			.backgroundGreatPlains{
				color: white !important;
                background-color: #e0a01f;
                transition: background .5s linear;
                border-color: transparent !important;
            }
            .backgroundOcean{
            	color: black !important;
                background-color: white;
                transition: background .5s linear;
                border-color: transparent !important;
            } 
            .backgroundAmazon{
            	color:white !important;
                background-color: #4f601f;
                transition: background .5s linear;
                border-color: transparent !important;
            }
            .backgroundForest{
            	color: white !important;
                background-color: #8fd471;
                transition: background .5s linear;
                border-color: transparent !important;
            }
            .backgroundDesert{
            	color: white !important;
                background-color: #9a6d32;
                transition: background .5s linear;
                border-color: transparent !important;
            } 
            .backgroundBeach{
            	color: white !important;
                background-color: #e4c39a;
                transition: background .5s linear;
                border-color: transparent !important;
            }   
            .backgroundNYC{
            	color: black !important;
                background-color: #f1f3f3;
                transition: background .5s linear;
                border-color: transparent !important;
            }
            .backgroundRural{
            	color: white !important;
                background-color: #669999;
                transition: background .5s linear;
                border-color: transparent !important;
            }  
            .backgroundice{
            	color: white !important;
                background-color: #baf4f8;
                transition: background .5s linear;
                border-color: transparent !important;
            }
            .backgroundfire{
            	color: white !important;
                background-color: #ff0000;
                transition: background .5s linear;
                border-color: transparent !important;
            }  
</style>


// WEBPACK FOOTER //
// mobile.vue?4f76178a